module.exports = __webpack_public_path__ + "media/images/landing_pages/business_motor-a6355dcfc789aa04cc3020ee4aab1777.svg";